import React from "react";

const Dashboard = React.lazy(() => import("Pages/Dashboard"));
//auth
const Login = React.lazy(() => import("Pages/Authentication/Login"));
const ResetPassword = React.lazy(() => import("../Pages/Authentication/ResetPassword"));
const AppResetPassword = React.lazy(() => import("../Pages/Authentication/AppResetPassword"));
const ChangePassword = React.lazy(() => import("Pages/Authentication/ChangePassword"));

//Admin Users
const SubAdminUser = React.lazy(() => import("Pages/SubAdminUser"));
const AdminUser = React.lazy(() => import("Pages/AdminUser"));
const UserData = React.lazy(() => import("../Pages/Users/AllUserList"))
const InactiveUsersList = React.lazy(() => import("../Pages/Users/InactiveUsersList"))
const UsersTab = React.lazy(() => import("../Pages/Users/UserTab"));
const BlockUserList = React.lazy(() => import("../Pages/Users/BlockUserList"));
const ReportedUser = React.lazy(() => import("Pages/Users/ReportedUser"));
const UserKYC = React.lazy(() => import("../Pages/Users/UserKYC"));
const BankUPIrequest = React.lazy(() => import("../Pages/Users/BankUPIrequest"));
const UpdateUserMobileNumber = React.lazy(() => import("../Pages/Users/UpdateUserMobileNumber"));

//Games
const AddNewGame = React.lazy(() => import("../Pages/Games/AddNewGame"))
const AllGameList = React.lazy(() => import("../Pages/Games/AllGameList"))
const ApprovedGameList = React.lazy(() => import("../Pages/Games/ApprovedGameList"))
const PendingGameList = React.lazy(() => import("../Pages/Games/PendingGameList"))
const RejectedGameList = React.lazy(() => import("../Pages/Games/RejectedGameList"))
const ArchiveGames = React.lazy(() => import("../Pages/Games/ArchiveGames"));
const GameDetails = React.lazy(() => import("../Pages/Games/GameDetails"));
const GameHistory = React.lazy(() => import("../Pages/Games/GameHistory"));
const GamesTracking = React.lazy(() => import("../Pages/Games/GamesTracking"));

//Master
const SplashScreen = React.lazy(() => import("../Pages/Master/SplashScreen"));
const BotModule = React.lazy(() => import("../Pages/Master/BotModule"));
const Avatar = React.lazy(() => import("../Pages/Master/Avatar"));
const Document = React.lazy(() => import("../Pages/Master/Document"));
const LobbyLabel = React.lazy(() => import("../Pages/Master/LobbyLabel"));
const GenreCategory = React.lazy(() => import("../Pages/Master/GenreCategory"));
const MGPOnlinePlayer = React.lazy(() => import("../Pages/Master/MGPOnlinePlayer"));
// const InternalAdsList = React.lazy(() => import("../Pages/Master/InternalAdsList"));
const InternalAdsList = React.lazy(() => import("../Pages/Marketing/InternalAdsList"));
const GameModeDesignConfig = React.lazy(() => import("../Pages/Master/GameModeDesignConfig"));
const ReportReason = React.lazy(() => import("../Pages/Master/ReportReason"));
const QuickChat = React.lazy(() => import("../Pages/Master/QuickChat"));
const AppLanguage = React.lazy(() => import("../Pages/Master/AppLanguage"));
const PrivateRooms = React.lazy(() => import("../Pages/Master/PrivateRooms"));
const HubbleCouponOutOfIndia = React.lazy(() => import("../Pages/Master/HubbleCouponOutOfIndia"));
const ManageCountry = React.lazy(() => import("../Pages/Master/ManageCountry"));

//Design
const LoginScreen = React.lazy(() => import("../Pages/Design/LoginScreen"));
const HomeScreen = React.lazy(() => import("../Pages/Design/HomeScreen"));
const ReferAndEarnDesign = React.lazy(() => import("../Pages/Design/ReferAndEarn"));
const PaymentSettings = React.lazy(() => import("../Pages/Design/PaymentSettings"));
const KYCScreen = React.lazy(() => import("../Pages/Design/KYCScreen"));
const WalletScreen = React.lazy(() => import("../Pages/Design/WalletScreen"));

const Config = React.lazy(() => import("../Pages/Settings/Config"));
const FlagConfig = React.lazy(() => import("../Pages/Settings/FlagConfig"));
const RestrictGeo = React.lazy(() => import("../Pages/Settings/RestrictGeo"));
const AppAboutUs = React.lazy(() => import("../Pages/Settings/AppAboutUs"));
const AppFeedback = React.lazy(() => import("../Pages/Settings/AppFeedback"));
const AdsConfig = React.lazy(() => import("../Pages/Settings/AdsConfig"));

//Withdrawal
const BankAndUPI = React.lazy(() => import("../Pages/Withdrawal/BankAndUPI"));
const UserWithdrawalRequests = React.lazy(() => import("../Pages/Withdrawal/UserWithdrawalRequests"));

//Revenue
const GameWiseRevenue = React.lazy(() => import("../Pages/Revenue/GameWiseRevenue"));
const OverallRevenue = React.lazy(() => import("../Pages/Revenue/OverallRevenue"));
const TimeOutReportRevenue = React.lazy(() => import("../Pages/Revenue/TimeOutReportRevenue"));
const GSTRevenue = React.lazy(() => import("../Pages/Revenue/GSTRevenue"));
const PlatformReport = React.lazy(() => import("../Pages/Revenue/PlatformReport"));
const AdsWatchData = React.lazy(() => import("../Pages/Revenue/AdsWatchData"));
const RevenuePaymentHistory = React.lazy(() => import("../Pages/Revenue/PaymentHistory"));

//Bonus
const DailyWheelBonus = React.lazy(() => import("../Pages/Bonus/DailyWheelBonus"));
const DailyReward = React.lazy(() => import("../Pages/Bonus/DailyReward"));
const ReferAndEarn = React.lazy(() => import("../Pages/Bonus/ReferAndEarn"));
const CouponCode = React.lazy(() => import("../Pages/Bonus/CouponCode"));

const AnalyticsReport = React.lazy(() => import("../Pages/Analytics/AnalyticsReport"));
const AnalyticsOverviewReport = React.lazy(() => import("../Pages/Analytics/AnalyticsOverviewReport"));
const AnalyticsApplicationInstallReport = React.lazy(() => import("../Pages/Analytics/AnalyticsApplicationInstallReport"));
const AnalyticsRetentionReport = React.lazy(() => import("../Pages/Analytics/AnalyticsRetentionReport"));
const DailyReport = React.lazy(() => import("../Pages/Analytics/DailyReport"));
const GameAnalyticsReport = React.lazy(() => import("../Pages/Analytics/GameAnalyticsReport"));

const Offer = React.lazy(() => import("../Pages/Marketing/Offer"));
const Leaderboard = React.lazy(() => import("../Pages/Bonus/Leaderboard"));
const Maintenance = React.lazy(() => import("../Pages/Settings/Maintenance"));

const HelpAndSupport = React.lazy(() => import("../Pages/HelpAndSupport"));
const TDSModule = React.lazy(() => import("../Pages/TDS/TDSReport"));
const TDSFile = React.lazy(() => import("../Pages/TDS/TDSFile"));
const PopularGames = React.lazy(() => import("../Pages/PopularGames"));
const MGPRelease = React.lazy(() => import("../Pages/MGPRelease"));


const Website = React.lazy(() => import("../Pages/Website"));
const StorePack = React.lazy(() => import("../Pages/StorePack"));
const RemoveAdsPackage = React.lazy(() => import("../Pages/RemoveAdsPackage"));
const GamePlayRoomPackage = React.lazy(() => import("../Pages/GamePlayRoomPackage"));
const SDKManagement = React.lazy(() => import("../Pages/SDKManagement"));

const Levels = React.lazy(() => import("../Pages/Master/Levels"));
const GameWiseUserTDSReport = React.lazy(() => import("../Pages/TDS/TDSReport/AllGameTDSReportTab/GameWiseUserTDSReport"));
const ParticularUserWiseTDSReport = React.lazy(() => import("../Pages/TDS/TDSReport/AllGameTDSReportTab/ParticularUserWiseTDSReport"));
const NotificationModule = React.lazy(() => import("../Pages/Marketing/NotificationModule"));
const WithdrawalProcessingFees = React.lazy(() => import("../Pages/Withdrawal/WithdrawalProcessingFees"));

const CompanyLogo = React.lazy(() => import("../Pages/CompanyLogo"));

const PaymentGateway = React.lazy(() => import("../Pages/Withdrawal/PaymentGateway"));
//AddDipositHistory
const AddDipositHistory = React.lazy(() => import("../Pages/Withdrawal/CashHistory"));
//withdrawal
const UPITransaction = React.lazy(() => import("../Pages/Withdrawal/UPITransaction"));
const UserDepositRequest = React.lazy(() => import("../Pages/Withdrawal/UserDepositRequest"));
const WithdrawManually = React.lazy(() => import("../Pages/Withdrawal/WithdrawManually"));
const CashWithdrawal = React.lazy(() => import("../Pages/Withdrawal/CashHistory"));

//GST
const GSTFile = React.lazy(() => import("../Pages/GST/GSTFiling"))
const GSTReport = React.lazy(() => import("../Pages/GST/GSTReport"))



//history
const History = React.lazy(() => import("../Pages/History"));

//tournament
const Tournament = React.lazy(() => import("../Pages/Tournament/AddNewTurnament"));
const AllTournamentList = React.lazy(() => import("../Pages/Tournament/AllTurnamentList"));
const TournamentDocuments = React.lazy(() => import("../Pages/Tournament/TournamentDocuments"));
const TournamentTab = React.lazy(() => import("../Pages/Tournament/TournamentTab"));

export const PublicroutesArray = [
    { path: "/", exact: true, component: Login },
    { path: "/reset/:id/:id", component: ResetPassword, title: "Reset Password" },
    { path: "/app-reset-password/:id/:id", component: AppResetPassword, title: "Reset Password" },
];

export const PrivateroutesArray = [
    { path: "/dashboard", component: Dashboard, title: "Dashboard" },
    { path: "/change-password", component: ChangePassword, title: "Change Password" },
    { path: "/admin-users", component: AdminUser, title: "Admin Role" },
    //User
    { path: "Users", component: UserData, title: "Users" },
    //InactiveUsersList
    { path: "/inactive-users", component: InactiveUsersList, title: "Inactive Users" },
    { path: "users-tab/:id", component: UsersTab, title: "Users Details" },
    { path: "/user-reported", component: ReportedUser, title: "Reported Users" },
    { path: "/user-kyc", component: UserKYC, title: "Users KYC" },
    { path: "/bank-upirequest", component: BankUPIrequest, title: "Bank / UPI request" },
    { path: "/block-user", component: BlockUserList, title: "Blocked Users" },
    { path: "/user/update-mobile-number", component: UpdateUserMobileNumber, title: "Users Mobile Number Request" },
    //Game
    { path: "/games/all-games", component: AllGameList, title: "Games" },
    { path: "/games/approved-games", component: ApprovedGameList, title: "Approved Games" },
    { path: "/games/pending-games", component: PendingGameList, title: "Pending Games" },
    { path: "/games/rejected-games", component: RejectedGameList, title: "Rejected Games" },
    { path: "/games/archive-games", component: ArchiveGames, title: "Archive Games" },
    { path: "/games/add-game", component: AddNewGame, title: "Add New Game" },
    { path: "/game-tab/:id", component: GameDetails, title: "Game Details" },
    { path: '/game/game-history', component: GameHistory, title: "Game History" },
    { path: '/games/games-tracking', component: GamesTracking, title: "Games Tracking" },
    //Master
    { path: "/avatars", component: Avatar, title: "Avatar" },
    { path: "/games/category", component: GenreCategory, title: "Game Category" },
    { path: "/online-players", component: MGPOnlinePlayer, title: "Gamziz Online Players" },
    { path: "/documentation", component: Document, title: "Documentation" },
    { path: "/ads-list", component: InternalAdsList, title: "Promotion Banners" },
    { path: "/lobby-label", component: LobbyLabel, title: "Lobby Type" },
    { path: "/splash-screen", component: SplashScreen, title: "Splash Screen" },
    { path: "/bot", component: BotModule, title: "Bot" },
    { path: "/gameModeDesign", component: GameModeDesignConfig, title: "Game Mode Design" },
    { path: "/quick-chat", component: QuickChat, title: "Quick Chat" },
    { path: "/app-languages", component: AppLanguage, title: "App Languages" },
    { path: "/private-rooms", component: PrivateRooms, title: "Private Rooms" },
    { path: "/hubble-coupon-out-of-india", component: HubbleCouponOutOfIndia, title: "Hubble Coupon Out Of India Manage" },
    { path: "/manage-country", component: ManageCountry, title: "Manage Country" },
    { path: "/setting/ads-config", component: AdsConfig, title: "Ads Config" },

    //Design

    { path: "/LoginScreen", component: LoginScreen, title: "Login Screen" },
    { path: "/HomeScreen", component: HomeScreen, title: "Home Screen" },
    { path: "/referAndEarn", component: ReferAndEarnDesign, title: "Refer And Earn" },
    { path: "/PaymentSettings", component: PaymentSettings, title: "Payment Settings" },
    { path: "/KYCScreen", component: KYCScreen, title: "KYC Screen" },
    { path: "/WalletScreen", component: WalletScreen, title: "Wallet Screen" },

    //Add Diposit History
    { path: "/add-diposit-history", component: AddDipositHistory, title: "Add Diposit History" },
    //withdrawal
    { path: "/bank-and-upi", component: BankAndUPI, title: "Withdrawal Bank And UPI" },
    { path: "/user-withdrawal-requests", component: UserWithdrawalRequests, title: "Users Withdrawal Requests" },
    { path: "/cash-history", component: CashWithdrawal, title: "Add Cash History" },
    //setting
    { path: "/setting/config", component: Config, title: "Global Config" },
    { path: "/setting/restrict-geo", component: RestrictGeo, title: "Restrict Geo" },
    { path: "/setting/flag-config", component: FlagConfig, title: "Flag Config" },
    { path: "/app-about-us", component: AppAboutUs, title: "App About Us" },
    { path: "/app-feedback", component: AppFeedback, title: "App Feedback" },
    //revenue
    { path: "/notification", component: NotificationModule, title: "Notification" },
    { path: "/revenue/game-wise-revenue", component: GameWiseRevenue, title: "Game Revenue" },
    { path: "/revenue/overall-revenue", component: OverallRevenue, title: "Overall Revenue" },
    { path: "/revenue/time-out-report", component: TimeOutReportRevenue, title: "Time Out Report" },
    { path: "/revenue/ads-watch-data", component: AdsWatchData, title: "Ads Watch Data" },
    { path: "/ads-watch-data", component: AdsWatchData, title: "Ads Watch Data" },
    { path: "/revenue/payment-history", component: RevenuePaymentHistory, title: "Payment History" },
    { path: "/payment-history", component: RevenuePaymentHistory, title: "Payment History" },
    { path: "GST", component: GSTRevenue, title: "GST" },

    //bonus
    { path: "/leaderboard", component: Leaderboard, title: "Leaderboard" },
    { path: "/daily-wheel-bonus", component: DailyWheelBonus, title: "Daily Wheel Bonus" },
    { path: "/daily-reward", component: DailyReward, title: "Daily Reward" },
    { path: "/refer-and-earn", component: ReferAndEarn, title: "Refer & Earn" },
    { path: "/coupon-code", component: CouponCode, title: "Coupon Code" },
    { path: "/offer", component: Offer, title: "Offer" },

    { path: "/popular-games", component: PopularGames, title: "Popular Games" },
    { path: "/release", component: MGPRelease, title: "Gamziz Release" },
    { path: "/help-and-support", component: HelpAndSupport, title: "Help & Support" },

    { path: '/sub-adminUser', component: SubAdminUser, title: "Sub Admin User" },
    { path: "/levels", component: Levels, title: "Levels" },
    { path: "/website", component: Website, title: "Website" },
    { path: "/store-pack", component: StorePack, title: "Store Packs" },
    { path: "/remove-ads", component: RemoveAdsPackage, title: "Remove Ads" },
    { path: "/game-play-room-plans", component: GamePlayRoomPackage, title: "Game Play Room Plans" },
    { path: "/sdk-management", component: SDKManagement, title: "SDK Management" },


    { path: "/TDS-report", component: TDSModule, title: "TDS Report" },
    { path: "/tds-filing", component: TDSFile, title: "TDS Filing" },
    { path: "/game-user-tds-report/:id", component: GameWiseUserTDSReport, title: "TDS Report" },
    { path: "/tds-user-report/:id", component: ParticularUserWiseTDSReport, title: "TDS Report" },

    { path: '/withdrawalProcessingFee', component: WithdrawalProcessingFees, title: "Withdrawal Processing Fee" },
    { path: "/setting/maintenance", component: Maintenance, title: "Maintenance" },

    //AnalyticsApplicationInstallReport
    { path: "/analytics-report", component: AnalyticsReport, title: "Analytics Report" },
    { path: "/analytics-overview-report", component: AnalyticsOverviewReport, title: "Analytics Overview Report" },
    { path: "/analytics-application-install", component: AnalyticsApplicationInstallReport, title: "Application Install & Uninstall" },
    { path: "/analytics-retention-report", component: AnalyticsRetentionReport, title: "Retention Report" },
    { path: "/analytics-game-report", component: GameAnalyticsReport, title: "Game Analytics" },
    { path: "/daily-report", component: DailyReport, title: "Daily Report" },


    //CompanyLogo
    { path: '/company-logo', component: CompanyLogo, title: "Company Logo" },

    //settings
    { path: "payment-gateway", component: PaymentGateway, title: "Payment Gateway" },

    //withdrawal
    { path: '/user-deposit-request', component: UserDepositRequest, title: "User Deposit Manually" },
    { path: '/upi-qr-code', component: UPITransaction, title: "Add UPI QR Code" },
    { path: '/withdrawal-manually', component: WithdrawManually, title: "Withdraw Manually" },
    { path: '/platform-report', component: PlatformReport, title: "Platform Report" },

    // GST
    { path: "/gst-filing", component: GSTFile, title: "GST Filing" },
    { path: "/gst-report", component: GSTReport, title: "GST Report" },


    //ReportReason
    { path: '/report-reason', component: ReportReason, title: "Report Reason" },

    //History 
    { path: '/history', component: History, title: "History" },

    //tournament
    { path: '/add-tournament', component: Tournament, title: "Create Tournament" },
    { path: '/all-tournament', component: AllTournamentList, title: "All Tournament" },
    { path: '/tournament-documents', component: TournamentDocuments, title: "Tournament Documents" },
    { path: "tournament-tab/:id", component: TournamentTab, title: "Tournament Details" },
];

//GameCategory